<script setup lang="ts">
import { useTokenPayload } from '@/queries/auth/use-login';
import { DeviceAuthRole } from '@carvia/ros-client-types';
import { computed } from 'vue';
import CounterVideoWallView from './CounterVideoWallView.vue';
import CounterSignatureView from './CounterSignatureView.vue';

const { data: tokenPayload } = useTokenPayload();
const deviceRole = computed(() =>
  tokenPayload.value && 'deviceRole' in tokenPayload.value ? tokenPayload.value.deviceRole : null,
);
</script>

<template>
  <CounterVideoWallView v-if="deviceRole === DeviceAuthRole.COUNTER_VIDEO_WALL" />
  <CounterSignatureView v-else-if="deviceRole === DeviceAuthRole.COUNTER_SIGNATURE_IPAD" />
  <section v-else class="flex min-h-screen items-center justify-center bg-hazel-50 p-6">
    <div class="w-full max-w-lg rounded-lg bg-white p-8 text-center shadow-sm">
      <h1 class="text-xl font-semibold text-primary">Connected Device</h1>
      <p class="mt-2 text-sm text-gray-500">Authenticated device role:</p>
      <div class="mt-6 rounded-md bg-gray-100 px-4 py-3 text-lg font-medium text-primary">
        {{ deviceRole ?? 'Unknown role' }}
      </div>
    </div>
  </section>
</template>
